module.exports = __webpack_public_path__ + "media/images/ui__textArrowDownLight--dark-cf4b47df7a27714335d7949ddba45c41.png";